import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
var Handle = Slider.Handle;
export var DefaultHandle = function DefaultHandle(props) {
  var value = props.value,
      dragging = props.dragging,
      index = props.index,
      restProps = _objectWithoutProperties(props, ["value", "dragging", "index"]);

  return React.createElement(Handle, Object.assign({
    value: value
  }, restProps));
};
export var DefaultHandleWithTooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DefaultHandleWithTooltip, _React$Component);

  function DefaultHandleWithTooltip() {
    _classCallCheck(this, DefaultHandleWithTooltip);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultHandleWithTooltip).apply(this, arguments));
  }

  _createClass(DefaultHandleWithTooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          dragging = _this$props.dragging,
          index = _this$props.index,
          format = _this$props.format,
          restProps = _objectWithoutProperties(_this$props, ["value", "dragging", "index", "format"]);

      var formattedValue = format ? format(value) : value;
      return React.createElement(Tooltip, {
        overlay: formattedValue,
        visible: dragging,
        placement: "bottom",
        key: index
      }, React.createElement(Handle, Object.assign({
        value: value
      }, restProps)));
    }
  }]);

  return DefaultHandleWithTooltip;
}(React.Component);
export default DefaultHandle;